import { Component, ChangeDetectionStrategy, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable } from "rxjs";
import { switchMap } from "rxjs/operators";

import { WoundCareModel } from "../wound-care.model";
import { WoundCare } from "../../shared/types";

@Component({
	selector: "wound-care",
	templateUrl: "overview.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class WoundCareOverviewComponent {
	private readonly woundCareModel = inject(WoundCareModel);
	private readonly route = inject(ActivatedRoute);
	private readonly router = inject(Router);

	loading$: Observable<boolean> = this.woundCareModel.woundCareLoading$;
	// @ts-expect-error TS2531
	items$: Observable<WoundCare[]> = this.route.parent.parent.params.pipe(
		// @ts-expect-error TS2345
		switchMap(({ patient }: { patient: string }) => {
			this.woundCareModel.loadWoundCares(patient);

			return this.woundCareModel.getWoundCaresForPatient(patient);
		}),
	);

	openSlideshow(item: WoundCare) {
		const patient = this.getPatientFromRouteParams();
		this.router.navigate([patient, "woundcare", item.id, "slideshow"]);
	}

	goToDetails(item: WoundCare) {
		const patient = this.getPatientFromRouteParams();
		this.router.navigate([patient, "woundcare", item.id]);
	}

	private getPatientFromRouteParams(): string {
		// @ts-expect-error TS2531
		return this.route.parent.parent.snapshot.params.patient;
	}
}
